.container {
    display: flex;
    flex-direction: column;

    // Redeclare font-family to override GoogleMaps styling
    font-family: "Nobel Regular", sans-serif;
    font-size: 1rem;
    gap: 1rem;
    padding: 1.125rem;
    text-align: center;

    & hr {
        background-color: var(--color-black);
        border: none;
        display: block;
        height: 1px;
        margin: 0;
        width: 100%;
    }
}

.address {
    font-size: 1.125rem;
    font-style: normal;
    font-weight: 700;
    line-height: 1;
    margin-bottom: 0.5rem;
}

.centerContent {
    justify-content: center;
}

.button {
    composes: roundButton from "../../styles/buttons.module.scss";
}
